/**
 * Created by Xinhe on 2020/3/31.
 */
export default {
  inject: {
    sjFormItem: {
      default: ""
    }
  },
  computed: {
    validateState() {
      return this.sjFormItem ? this.sjFormItem.validateState : null;
    }
  }
};
